import { lazy, useEffect } from "react";
import logowhite from "../src/public/images/logowhite.svg";
import styles from "./route.module.css";
import { Routes, Route, Navigate, useLocation, useNavigate } from "react-router-dom";
import { getAuthToken } from "./axios.config.js";
import { Customer } from "./Component/index.js";
import Mcb from "./Component/Mcb/Mcb.js";
const CreateRole = lazy(() => import("./Component/Role/CreateRole"));
const EventManagement = lazy(() => import("./Component/EventManangement/EventManagement"));
// const Customer = lazy(() => import("./Component/Customer"));
const Report = lazy(() => import("./Component/Report"));
const ForgotPassword = lazy(() =>
  import("./Component/ForgotPassword/ForgotPassword")
);
const AddFeature = lazy(() => import("./Component/AddFeature/AddFeature.js"));
const AddRole = lazy(() => import("./Component/AddRole/Role"));
const DownloadReports = lazy(() =>
  import("./Component/DownloadReports/ReportDownload")
);
const InnerLayout = lazy(() => import("./Component/Layout/InnerLayout"));
const CommonTable = lazy(() => import("./Common/CommonTable/CommonTable"));
// const Mcb = lazy(() => import("./Component/Mcb/Mcb"));
const EditCouponForm = lazy(() => import("./Component/Coupons/EditCouponForm"));
const Home = lazy(() => import("./Component/Home"));
const CreateCoupon = lazy(() => import("./Component/Coupons/CreateCoupons"));
const TwoFactorLogin = lazy(() => import("./Component/Login/TwoFactorLogin"));
const Users = lazy(() => import("./Component/Role/Users"));
const ActivityLogger = lazy(() =>
  import("./Component/ActivityLogger/ActivityLogger")
);
const Orders = lazy(() => import("./Component/Orders/Orders"));
const Partner = lazy(() => import("./Component/partnerManagement/index"));
const Transactions = lazy(() =>
  import("./Component/McbTransactions/Transactions")
);
const PartnerRates = lazy(() =>
  import("./Component/Mcb/PartnerRates/PartnerRates")
);
const PartnerBeneficiaries = lazy(() => import("./Component/Mcb/PartnerBeneficiaries/index.js"));
const Beneficiary = lazy(() => import("./Component/Mcb/BeneficiaryList/index.js"));
const Reports = lazy(() => import("./Component/McbReport/Reports.js"));
const EasyRemit = lazy(() => import("./Component/EasyRemit/EasyRemit"));
const RecentTransaction = lazy(() =>
  import("./Component/RecentTransaction/RecentTransaction")
);
const CouponList = lazy(() => import("./Component/Coupons/CouponList"));
const PlanTable = lazy(() => import("./Component/Plans/index"));
const PartnerTable = lazy(() => import("./Component/Partner/index"));
const InvestingPlan = lazy(() => import("./Component/PlanManagement/index.js"));
const PageNotFound = lazy(() => import("./PageNotFound.js"));
const Coupons = lazy(() => import("./Component/InvestingCoupons/Coupons.js"));

const CustomRoute = () => {
  return (
    <Routes>
      <Route
        exact
        path="/login"
        element={
          getAuthToken() ? (
            <LoginRedirectHandler />
          ) : (
            <Layout>
              <TwoFactorLogin />
            </Layout>
          )
        }
      />
      <Route
        exact
        path="/forgot-password"
        element={
          getAuthToken() ? (
            <ProtectedRoute>
              <ForgotPassword />
            </ProtectedRoute>
          ) : (
            <Layout>
              <ForgotPassword />
            </Layout>
          )
        }
      />
      <Route
        exact
        path="/"
        element={
          <ProtectedRoute>
            <Home />
          </ProtectedRoute>
        }
      />
      <Route
        exact
        path="/customer"
        element={
          <ProtectedRoute>
            <Customer />
          </ProtectedRoute>
        }
      />
      <Route
        exact
        path="/customer/:id"
        element={
          <ProtectedRoute>
            <Customer />
          </ProtectedRoute>
        }
      />

      <Route
        exact
        path="/report"
        element={
          <ProtectedRoute>
            <Report />
          </ProtectedRoute>
        }
      />
      <Route
        exact
        path="/orders"
        element={
          <ProtectedRoute>
            <Orders />
          </ProtectedRoute>
        }
      />
      <Route
        exact
        path="/Investing-Plan"
        element={
          <ProtectedRoute>
            <InvestingPlan />
          </ProtectedRoute>
        }
      />
        <Route
        exact
        path="/Investing-Coupons"
        element={
          <ProtectedRoute>
            <Coupons />
          </ProtectedRoute>
        }
      />
      <Route
        exact
        path="/partners"
        element={
          <ProtectedRoute>
            <Partner />
          </ProtectedRoute>
        }
      />
      <Route
        exact
        path="/easy-remit"
        element={
          <ProtectedRoute>
            <EasyRemit />
          </ProtectedRoute>
        }
      />
      <Route
        exact
        path="/recent-transaction"
        element={
          <ProtectedRoute>
            <RecentTransaction />
          </ProtectedRoute>
        }
      />
      <Route
        exact
        path="/coupons"
        element={
          <ProtectedRoute>
            <CouponList />
          </ProtectedRoute>
        }
      />
      <Route
        exact
        path="/edit-coupon/:couponCode"
        element={
          <ProtectedRoute>
            <EditCouponForm />
          </ProtectedRoute>
        }
      />
      <Route
        exact
        path="/create-coupon"
        element={
          <ProtectedRoute>
            <CreateCoupon />
          </ProtectedRoute>
        }
      />
      <Route
        exact
        path="/Create-Plan"
        element={
          <ProtectedRoute>
            <PlanTable />
          </ProtectedRoute>
        }
      />
      <Route
        exact
        path="/Create-Partner"
        element={
          <ProtectedRoute>
            <PartnerTable />
          </ProtectedRoute>
        }
      />
      <Route
        exact
        path="/mcb"
        element={
          <ProtectedRoute>
            <Mcb />
          </ProtectedRoute>
        }
      />
      <Route
        exact
        path="/mcb/:id"
        element={
          <ProtectedRoute>
            <Mcb />
          </ProtectedRoute>
        }
      />
      <Route
        exact
        path="/transactions"
        element={
          <ProtectedRoute>
            <Transactions />
          </ProtectedRoute>
        }
      />
      <Route
        exact
        path="/partner-rates"
        element={
          <ProtectedRoute>
            <PartnerRates />
          </ProtectedRoute>
        }
      />
      <Route
        exact
        path="/partner-beneficiaries"
        element={
          <ProtectedRoute>
            <PartnerBeneficiaries />
          </ProtectedRoute>
        }
      />
      <Route
        exact
        path="/beneficiary"
        element={
          <ProtectedRoute>
            <Beneficiary />
          </ProtectedRoute>
        }
      />
      <Route
        exact
        path="/user-reports"
        element={
          <ProtectedRoute>
            <Reports />
          </ProtectedRoute>
        }
      />
      <Route
        exact
        path="/create-user"
        element={
          <ProtectedRoute>
            <CreateRole />
          </ProtectedRoute>
        }
      />
       <Route
        exact
        path="/event-management"
        element={
          <ProtectedRoute>
            <EventManagement />
          </ProtectedRoute>
        }
      />
      <Route
        exact
        path="/Users"
        element={
          <ProtectedRoute>
            <Users />
          </ProtectedRoute>
        }
      />
      <Route
        exact
        path="/add-features"
        element={
          <ProtectedRoute>
            <AddFeature />
          </ProtectedRoute>
        }
      />
      <Route
        exact
        path="/add-role"
        element={
          <ProtectedRoute>
            <AddRole />
          </ProtectedRoute>
        }
      />
      <Route
        exact
        path="/activity-logger"
        element={
          <ProtectedRoute>
            <ActivityLogger />
          </ProtectedRoute>
        }
      />
      <Route
        exact
        path="/download-report"
        element={
          <ProtectedRoute>
            <DownloadReports />
          </ProtectedRoute>
        }
      />
      <Route
        exact
        path="/table-page"
        element={
          <ProtectedRoute>
            <CommonTable />
          </ProtectedRoute>
        }
      />

      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
};

const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const token = getAuthToken();
  if (!token || !token.access_token) {
    const redirectTo = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?redirectTo=${redirectTo}`} replace />;
  }
  const urlParams = new URLSearchParams(location.search);
  const hasCustomerId = urlParams.has("id");
  const hasMcbId = urlParams.has("id");
  const showLogo =
    (location.pathname.startsWith("/customer") && hasCustomerId) ||
    (location.pathname.startsWith("/mcb") && hasMcbId)
   if (showLogo)  {
    return (
      <div style={{backgroundColor: "var(--theme-loginbg"}}>
         <div className={styles.navBar}
        >
          <img src={logowhite} className={styles.logo} alt="brand_logo" />
        </div>
      <div
        style={{
          padding: "20px",
          backgroundColor: "var(--theme-colorbg) !important",
        }}
      >
        {children}
      </div>
      </div>
    );
  }
  return <InnerLayout>{children}</InnerLayout>;
};
const LoginRedirectHandler = () => {
  const location = useLocation();
  const navigate = useNavigate();
  
  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const redirectTo = urlParams.get('redirectTo');
    
    if (redirectTo) {
      const decodedPath = decodeURIComponent(redirectTo);
      navigate(decodedPath, { replace: true });
    } else {
      navigate('/', { replace: true });
    }
  }, [location, navigate]);

  return null;
};

const Layout = ({ children }) => {
  const location = useLocation();
  const didMatch = location.pathname === "/login";
  const token = getAuthToken();
  if (token && token.access_token && !didMatch) {
    return <InnerLayout>{children}</InnerLayout>;
  } else {return <div style={{ height: "100vh" }}>{children}</div>;}
};

export default CustomRoute;
